// client/src/components/leagues/MatchScheduler.js
import { useParams } from 'react-router-dom'
import PageLayout from '../common/layout/PageLayout'
import DeleteDayAvailabilityModal from '../scheduling/DeleteDayAvailabilityModal'
import { useMatchScheduler } from '../../hooks/useMatchScheduler'

export default function MatchScheduler() {
  const { leagueId, matchId } = useParams()
  
  const {
    matchDatetime,
    setMatchDatetime,
    submitting,
    existingStatus,
    homeCourt,
    awayCourt,
    showDeleteModal,
    matchData,
    loading,
    handleSubmit,
    handleDeleteModalClose,
  } = useMatchScheduler(matchId, leagueId)

  if (loading) {
    return (
      <PageLayout title="Schedule Match">
        <div className="container">
          <p className="text-muted">Loading match details...</p>
        </div>
      </PageLayout>
    )
  }

  return (
    <PageLayout
      title={
        existingStatus === 'scheduled' ? 'Reschedule Match' : 'Schedule Match'
      }
    >
      <div className="container">
        <p className="text-muted mb-2">
          Match #{matchId} – League #{leagueId}
        </p>
        {(homeCourt || awayCourt) && (
          <div className="alert alert-info">
            <div className="small mb-1">
              <strong>Home Courts</strong>
            </div>
            {homeCourt && (
              <div className="small">
                Home:{' '}
                {[
                  homeCourt.name,
                  homeCourt.address_line1,
                  homeCourt.city,
                  homeCourt.state,
                  homeCourt.zip,
                ]
                  .filter(Boolean)
                  .join(', ')}
              </div>
            )}
            {awayCourt && (
              <div className="small">
                Away:{' '}
                {[
                  awayCourt.name,
                  awayCourt.address_line1,
                  awayCourt.city,
                  awayCourt.state,
                  awayCourt.zip,
                ]
                  .filter(Boolean)
                  .join(', ')}
              </div>
            )}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="matchDatetime" className="form-label">
              Select Date & Time
            </label>
            <input
              type="datetime-local"
              className="form-control"
              id="matchDatetime"
              value={matchDatetime}
              onChange={(e) => setMatchDatetime(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            disabled={submitting}
            data-track="match.schedule_submit"
          >
            {submitting
              ? existingStatus === 'scheduled'
                ? 'Rescheduling...'
                : 'Scheduling...'
              : existingStatus === 'scheduled'
              ? 'Reschedule Match'
              : 'Schedule Match'}
          </button>
        </form>
      </div>

      {/* Deletion modal for scheduled matches */}
      {showDeleteModal && matchData && (
        <DeleteDayAvailabilityModal
          isOpen={showDeleteModal}
          onClose={handleDeleteModalClose}
          matchDate={matchDatetime}
          leagueId={leagueId}
          divisionId={matchData.division_id}
          opponentName={matchData.opponentName}
        />
      )}
    </PageLayout>
  )
}
